import React, { ReactElement } from 'react';
import { Button, Col, Dropdown, DropdownButton, Nav, Navbar, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { useRecoilState } from 'recoil';
import { etatUtilisateurConnecte } from '../../State';
import { fermerSession } from '../../Utils/api';
import LanguageSwitcher, { PAGES_FULLY_TRANSLATED } from '../Common/LanguageSwitcher';

import BarreRecherche from './BarreRecherche/BarreRecherche';

export interface PropsDashboardNavbar {
    affichageActivitePublic: boolean;
    setAffichageActivitePublic: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DashboardNavbar(props: PropsDashboardNavbar): ReactElement {
    const { affichageActivitePublic, setAffichageActivitePublic } = props;
    const navigate = useNavigate();
    const [utilisateurConnecte, setEtatUtilisateurConnecte] = useRecoilState(etatUtilisateurConnecte);
    const location = useLocation();

    return (
        <Navbar bg="light" className="position-sticky " style={{ top: 0 }}>
            <Row className="flex-fill">
                <Col>
                    <BarreRecherche />
                </Col>
                <Col className="flex-lg-grow-0 pt-2 pt-lg-0">
                    <Navbar.Collapse id="basic-navbar-nav">
                        {utilisateurConnecte.connecte ? (
                            <>
                                <DropdownButton
                                    id="dropdown-basic-button"
                                    variant="outline-secondary"
                                    title={
                                        utilisateurConnecte.prenom
                                            ? utilisateurConnecte.prenom + ' ' + utilisateurConnecte.nom
                                            : utilisateurConnecte.nom
                                    }
                                >
                                    <Dropdown.Item
                                        onClick={() => {
                                            navigate('/profile', { replace: true });
                                        }}
                                    >
                                        Profil
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() => {
                                            fermerSession();
                                            navigate('/', { replace: true });
                                            setEtatUtilisateurConnecte({
                                                id: 0,
                                                connecte: false,
                                                admin: false,
                                                nom: '',
                                                prenom: '',
                                                mettreAJourMotDePasse: false,
                                            });
                                        }}
                                    >
                                        Se&nbsp;déconnecter
                                    </Dropdown.Item>
                                </DropdownButton>
                            </>
                        ) : (
                            <LinkContainer to="/login">
                                <Nav.Link as={Button} variant="outline-primary" size="sm" className="w-100">
                                    Se&nbsp;connecter
                                </Nav.Link>
                            </LinkContainer>
                        )}
                    </Navbar.Collapse>
                </Col>

                {PAGES_FULLY_TRANSLATED.includes(location.pathname) ? (
                    <Col className="flex-lg-grow-0 pt-2 pt-lg-0">
                        <LanguageSwitcher />
                    </Col>
                ) : undefined}
            </Row>
        </Navbar>
    );
}
